import React, { Component } from "react";
import "./style.scss";
import default_logo from "assets/images/headerLogo.png";

class LuxelleNew extends Component {
  getTotalCount = () => {
    const { responseData } = this.props;
    if (responseData.dtl_data) {
      return responseData.dtl_data.reduce(
        (total, item) => total + item.dt_qty,
        0
      );
    }
    return 0;
  };

  //   componentDidMount = () => {
  //     window.print();
  //   };

  render() {
    const {
      accountHeader,
      responseData,
      Flag,
      landscape = false,
      currency,
    } = this.props;
    console.log(accountHeader, "itemAccount");
    console.log(responseData, "responseData");
    let {
      hdr_data = [],
      dtl_data = [],
      sub_data = {},
      taud_data = [],
      footer = {},
      company_hdr = {},
      taud_sub = {},
    } = responseData;
    let {
      showprepaid,
      prepaidlst,
      treatment = [],
      treatmentbal = false,
    } = footer;
    const getTotalCount = () => {
      if (dtl_data) {
        var totalCount = dtl_data.reduce(
          (total, item) => total + item.dt_qty,
          0
        );
      }
      console.log(dtl_data, "detailData");
      return totalCount;
    };
    return (
      <div className="thermal-page">
        <div className="section">
          {accountHeader?.logo ? (
            <img src={accountHeader.logo} className="logo" alt="Logo" />
          ) : (
            <img src={default_logo} className="logo" alt="Default Logo" />
          )}
          <div className="headerText">
            <h1 className="headerTitle">
              {accountHeader?.name || "Beautesoft"}
            </h1>
            <p className="subtitle">
              {accountHeader?.address ||
                "211 Holland Ave, Holland Road Shopping Center #0343 Singapore 278969 Apt: 6469 9141 | Whatsapp: 8121 4779"}
            </p>
          </div>
        </div>

        <div>
          {company_hdr?.gst_reg_no && (
            <div className="footerData">
              Gst Reg No: {company_hdr?.gst_reg_no}
            </div>
          )}
          {hdr_data?.invoice_header && (
            <div className="footerData">{hdr_data?.invoice_header}</div>
          )}
          <div className="footerData">
            Reciept: {hdr_data ? hdr_data?.trans : "N/A"}
          </div>
          {hdr_data?.void_refno && (
            <div className="footerData">
              Void Reciept: {hdr_data?.void_refno}
            </div>
          )}
          <div className="tableHeader">
            <div className="qty ">{`Qty`}</div>
            <div className="description mx-3">{`Item`}</div>
            <div className="tablePayment textalignCommonCenter">{`Amt`}</div>
          </div>
          <div className="borderTopCommon" />

          {dtl_data?.length > 0 &&
            dtl_data?.map((item, index) => {
              console.log(item, "item");
              return (
                <div key={index}>
                  <div className="tableBody">
                    <div className="qty">{item?.dt_qty}</div>
                    <div className="description">{item?.dt_itemdesc}</div>
                    {item?.dt_deposit && (
                      <div className="tablePayment">
                        {currency} {item?.dt_deposit}
                      </div>
                    )}
                  </div>
                  <div className="consultContainer ">
                    {item?.sales_staff && item?.sales_staff !== " " && (
                      <div className="consultTitle marginBottom0">
                        Sold By : <div>{item?.sales_staff}</div>
                      </div>
                    )}
                    {item?.work_staff && item?.work_staff !== " " && (
                      <div className="consultTitle">
                        Service By : <div>{item?.work_staff}</div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          {/* <div className="borderTopCommon" /> */}
          <div className="loginInfo">
            <div className="tableBody">
              <div className="descriptionSubTotal">{`Sub Total`}</div>
              {sub_data?.sub_total && (
                <div className="Total">
                  {" "}
                  {currency}
                  {sub_data?.sub_total}
                </div>
              )}
            </div>
            <div className="tableBody">
              <div className="descriptionSubTotal">{`${
                currency === "$" ? "GST" : "Tax"
              }`}</div>
              <div className="Total">
                {" "}
                {currency}
                {taud_sub?.gst ? taud_sub?.gst : "0.00"}
              </div>
            </div>
            <div className="tableBody">
              <div className="descriptionTotal">{`Total`}</div>
              {taud_sub?.grand_tot && (
                <div className="Total">
                  {" "}
                  {currency}
                  {taud_sub?.grand_tot}
                </div>
              )}
            </div>
            <div className="tableBody">
              <div className="descriptionTotal">{`OutStanding`}</div>
              {sub_data?.outstanding && (
                <div className="Total">
                  {" "}
                  {currency}
                  {sub_data?.outstanding ? sub_data?.outstanding : "0.00"}
                </div>
              )}
            </div>
            <div className="marginTop3">
              <div className="descriptionSubTotal">{`Payment Type :`}</div>
            </div>
          </div>

          <div className="loginInfo">
            {taud_data &&
              taud_data.length > 0 &&
              taud_data.map((item, index) => {
                return (
                  <div className="courseContainer" key={index}>
                    <div className="paymentType width75">
                      {item?.pay_type_name}
                    </div>
                    <div className="paymentType width25 textalignCommonRight">
                      {currency} {item?.pay_amt}
                    </div>
                  </div>
                );
              })}
          </div>

          {treatmentbal && (
            <div>
              <div className="borderTopCommon" />
              <div className="tableHeader">
                <div className="descriptionCourse">{`Course`}</div>
                <div className="paymentCourse">{`Count`}</div>
              </div>
              <div className="borderTopCommon" />
            </div>
          )}
          {treatmentbal &&
            treatment &&
            treatment?.length > 0 &&
            treatment?.map((item, index) => {
              return (
                <div key={index}>
                  <div className="courseContainer">
                    <div className="descriptionCourse">{item?.course}</div>
                    {item?.total && (
                      <div className="thermal-payment paymentCourse textalignCommonRight">
                        {" "}
                        {item?.total}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}

          {/* <div className="dummySpace" /> */}
          <div className="borderTopCommon" />

          <div className="consultContainer">
            <div className="consultTitle">
              Customer :{" "}
              <div>
                {hdr_data?.sa_custname}{" "}
                {hdr_data?.cust_phone2 && `(${hdr_data?.cust_phone2})`}{" "}
              </div>
            </div>
            <div className="itemContainer">
              <div className="consultTitle">
                Item Qty : <div>{dtl_data && getTotalCount(dtl_data)}</div>
              </div>
              {/* {hdr_data?.issued && (
            <div className="consultTitle">
              Cashier : <div>{hdr_data ? hdr_data?.issued : ""}</div>
            </div>
          )} */}
            </div>

            <div className="consultTitle">
              Date :{" "}
              <div>
                {hdr_data?.sa_date} {hdr_data?.sa_time}
              </div>
            </div>
            {footer?.footer1 && (
              <div className="consultTitle">{footer?.footer1}</div>
            )}
            {footer?.footer2 && (
              <div className="consultTitle">{footer?.footer2}</div>
            )}
            {footer?.footer3 && (
              <div className="consultTitle">{footer?.footer3}</div>
            )}
          </div>
          <div className="thankYou">
            <div className="thankYouData">Thank You, See You Again!</div>
          </div>
        </div>
      </div>
    );
  }
}

export default LuxelleNew;
